import React, { useState } from 'react';
import { sitesService } from '../../_services/sites.service';
import useSites, { groupSites } from './useSites';
import toast from '../shared/Toast';
import './multiLocation.css';

/** "Apply to all locations" — copies one settings area from this site to the others (spec §14 M5). Owner + 2 sites only. */
export default function ApplyToAllLocations({ area, label }) {
    const { inGroup, canAddLocation, sites, group } = useSites();
    const [state, setState] = useState('idle');
    if (!inGroup || !canAddLocation) return null;
    const others = groupSites({ sites, group }).filter(s => !s.isActive);
    const run = async () => {
        if (!window.confirm(`Copy ${label || area} settings from this location to ${others.length} other location${others.length === 1 ? '' : 's'}?`)) return;
        setState('busy');
        try {
            const r = await sitesService.pushSettings([area], []);
            // Say where it did not land, instead of "Applied" for a copy that skipped a location.
            const name = new Map(sites.map(s => [String(s.salonId), s.salonName]));
            const gaps = ((r && r.report) || []).filter(x => x.skipped && x.skipped.length);
            if (gaps.length) {
                toast.error(gaps.map(x => `${name.get(String(x.salonId)) || 'A location'}: ${x.skipped.map(k => k.reason).join(', ')}`).join('. '));
                setState('partial');
            } else setState('done');
            setTimeout(() => setState('idle'), 2500);
        }
        catch (e) { console.error(e); setState('error'); }
    };
    return (
        <button type="button" className="ml-chip ml-chip--action" onClick={run} disabled={state === 'busy'} style={{ marginLeft: 'auto' }}>
            {state === 'busy' ? 'Applying…' : state === 'done' ? 'Applied to all locations' : state === 'partial' ? 'Applied, with gaps' : state === 'error' ? 'Could not apply' : 'Apply to all locations'}
        </button>
    );
}
